export default "__VITE_ASSET__Yvh6Z_jA__"